<template>
  <v-container width="100%" style="background: #f5f5f5">
    <v-dialog v-model="editDialog" max-width="900px">
      <ManageTask
        :title="$t('Editar tarefa')"
        :labor="currentLabor"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>
    <div id="header" class="mt-5 px-3">
      <h2>{{ $t('Dados da tarefa') }}</h2>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="currentLabor.eLaborStatus === 1 && userType == 2"
              v-show="userType < 4 || userType == 8"
              class="ma-1"
              color="#f5f5f5"
              @click="editTask(currentLabor)"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon dark color="#0F3565"> mdi-pencil-outline </v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              color="#F5F5F5"
              dark
              @click="generatePDF(currentLabor)"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon color="#0F3565"> mdi-printer </v-icon>
            </v-btn>
          </template>
          <span>Imprimir</span>
        </v-tooltip>
      </div>
    </div>
    <v-divider class="my-3"></v-divider>

    <v-row class="px-5">
      <v-col class="py-0" cols="12">
        <p>
          <strong class="field">{{ $t('Tarefa') }}:</strong>
          {{ currentLabor.name }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Instituição') }}:</strong>
          {{ institution.name }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Unidade') }}:</strong>
          {{ unidadeName }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">Nº {{ $t('Tarefa') }}:</strong>
          {{ currentLabor.number }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Responsável') }}:</strong>
          {{ userName }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Solicitante') }}:</strong>
          {{ currentLabor.requester }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Tipo') }}:</strong>
          {{ laborTypes[currentLabor.eLaborType] }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Setor') }}:</strong>
          {{ departmentName }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Data e hora') }}:</strong>
          {{ formatDate(currentLabor.laborDate) }}
        </p>
      </v-col>
      <v-col cols="8" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Estado') }}</strong>
          {{ laborsStatus[currentLabor.eLaborStatus] }}
        </p>
      </v-col>
      <v-col
        cols="6"
        sm="4"
        md="4"
        lg="4"
        v-if="currentLabor.eLaborStatus === 1"
      >
        <p>
          <strong class="field">{{ $t('Data e hora fechamento') }}</strong>
          {{ formatDate(currentLabor.closeDate) }}
        </p>
      </v-col>
      <v-col
        cols="6"
        sm="4"
        md="4"
        lg="4"
        v-if="currentLabor.eLaborStatus === 1"
      >
        <p>
          <strong class="field">{{ $t('Horas despendidas') }}</strong>
          {{ currentLabor.hoursSpent }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
#header {
  display: flex;
  justify-content: space-between;
}
.field {
  display: block;
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import Utils from '../../../../Utils/FormatDate'
import ManageTask from './ManageTask.vue'

export default {
  props: {
    receivedLabor: {
      type: Object,
      required: true,
    },
  },

  components: {
    ManageTask,
  },

  created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.currentLabor = this.receivedLabor
    this.getUnidade()
    this.getDepartment()
    this.getUser()
  },

  data: () => ({
    institution: {},
    currentLabor: {},
    dialogKey: false,
    editDialog: false,
    unidadeName: '',
    departmentName: '',
    userName: '',
    users: [],
    userType: null,
    laborTypes: [
      'Validação de equipamentos',
      'Treinamento',
      'Serviço administrativo',
      'Rotina de inspeção',
      'Serviço Operacional',
    ],
    laborsStatus: ['Aberta', 'Fechada'],
    apiService: new ApiService(),
  }),

  methods: {
    close() {
      this.$emit('close')
    },

    closeDialog() {
      this.editDialog = false
      this.dialogKey = !this.dialogKey
    },

    editTask(labor) {
      this.currentLabor = labor
      this.editDialog = true
      this.dialogKey = !this.dialogKey
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    async getUnidade() {
      const unidadeId = this.currentLabor.unidadeId

      if (unidadeId != null) {
        await this.apiService
          .get(`unidade/${this.institution.id}/${unidadeId}`)
          .then((response) => {
            this.unidadeName = response.content.name
          })
      }
    },

    async getDepartment() {
      const departmentId = this.currentLabor.departmentId

      if (departmentId != null) {
        await this.apiService
          .get(`department/${departmentId}`)
          .then((response) => {
            this.departmentName = response.content.name
          })
      }
    },

    async getUser() {
      const userId = this.currentLabor.userId
      const institutionId = this.currentLabor.institutionId

      if (userId != null) {
        await this.apiService
          .get(`user/list/${institutionId}`)
          .then((response) => {
            this.userName = response.content.find(
              (user) => user.id == userId
            ).name
          })
      }
    },

    async generatePDF(labor) {
      this.apiService
        .get(`labor/printlabor/${labor.id}`)
        .then((response) => {
          response = 'data:application/pdf;base64,' + response.content
          const link = document.createElement('a')
          link.href = response
          link.setAttribute(
            'download',
            `Tarefa:${labor.id}_${this.formatDate(labor.laborDate)}`
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(() => {})

      this.$emit('show', 'Baixando PDF!')
    },
  },
}
</script>

<style></style>
